import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "open-cooperation-child" }
const _hoisted_2 = { class: "shuzhi-form" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "shuzhi-form" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "shuzhi-form" }
const _hoisted_7 = ["src"]

import { ref, reactive, watch, onMounted } from 'vue'
import { asynchronousRetrieval } from '@/utils'
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenCooperation',
  setup(__props) {

const router = useRouter()
const loadUrl: any = ref({})

onMounted(async () => {
  const shuzhi: any = await asynchronousRetrieval('nfznxr-images/shuzhi.png');
  const zhongduan: any = await asynchronousRetrieval('nfznxr-images/zhongduan.png');
  const Bduan: any = await asynchronousRetrieval('nfznxr-images/Bduan.png');
  loadUrl.value = { shuzhi, zhongduan, Bduan }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.shuzhi
      }, null, 8, _hoisted_3),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text" }, "我是数智产品品牌方", -1)),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/counselling?type=1')))
      }, "合作咨询")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: loadUrl.value.zhongduan
      }, null, 8, _hoisted_5),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text" }, "我是渠道端/零售终端", -1)),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/counselling?type=2')))
      }, "合作咨询")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: loadUrl.value.Bduan
      }, null, 8, _hoisted_7),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text" }, "我是B/G端需求方", -1)),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/counselling?type=3')))
      }, "合作咨询")
    ])
  ]))
}
}

})